import { Record } from 'immutable'

const IntegrationEventRecord = Record({
  timeStamp: '',
  message: '',
  status: undefined,
})

export default IntegrationEventRecord
